import React from 'react';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
const useStyles = makeStyles((theme) => ({
    titleContainer: {
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center'
        },
        marginBottom: theme.spacing(1)
    },
    titleIcon: {
        marginRight: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    }
}));
export const FormPage = (props) => {
    const classes = useStyles();
    const { children, pageTitle, pageIcon, size } = props;
    const sizeProps = size == null ? { xs: 10, md: 8, lg: 6 }
        : typeof size === 'object' ? size
            : { xs: size };
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Grid, { container: true, justify: 'center' },
                React.createElement(Grid, Object.assign({ item: true }, sizeProps),
                    React.createElement(Grid, { container: true, alignItems: 'center', className: classes.titleContainer },
                        pageIcon ? React.createElement(Grid, { item: true, "data-testid": 'form-page-icon', className: classes.titleIcon }, pageIcon) : '',
                        React.createElement(Grid, { item: true },
                            React.createElement(Typography, { component: 'h1', variant: 'h5' }, pageTitle)))))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Grid, { container: true, justify: 'center' },
                React.createElement(Grid, Object.assign({ item: true }, sizeProps), children)))));
};
//# sourceMappingURL=FormPage.js.map